import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableThDefaultVariants = {}
const tableThCompoundVariants = []

const tableThSlotNames = [
  [
    "root",
    "table-th__root"
  ],
  [
    "content",
    "table-th__content"
  ],
  [
    "cta",
    "table-th__cta"
  ]
]
const tableThSlotFns = /* @__PURE__ */ tableThSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableThDefaultVariants, getSlotCompoundVariant(tableThCompoundVariants, slotName))])

const tableThFn = memo((props = {}) => {
  return Object.fromEntries(tableThSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableThVariantKeys = []
const getVariantProps = (variants) => ({ ...tableThDefaultVariants, ...compact(variants) })

export const tableTh = /* @__PURE__ */ Object.assign(tableThFn, {
  __recipe__: false,
  __name__: 'tableTh',
  raw: (props) => props,
  variantKeys: tableThVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, tableThVariantKeys)
  },
  getVariantProps
})